import { useTranslator } from '@Localization';
import { orderBy } from 'lodash';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { AnnotationToolType } from '../../../../../../../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { Select } from '../../../../../../../../design/inputs/select/Select';
import { S_FieldLabel } from '../../../../../../../../design/labels/fieldLabel/S_FIeldLabel';

interface IProps {
  toolType: AnnotationToolType;
  onChangeToolType(toolType: AnnotationToolType): void;
  disabled?: boolean;
}

export const ToolTypeField = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const options = orderBy(
    [
      { label: t('point'), value: AnnotationToolType.POINT },
      { label: t('rectangle'), value: AnnotationToolType.RECTANGLE },
      { label: t('polygon'), value: AnnotationToolType.POLYGON },
      { label: t('vector'), value: AnnotationToolType.VECTOR },
      { label: t('polyline'), value: AnnotationToolType.POLYLINE },
      { label: t('rotatedrectangle'), value: AnnotationToolType.ROTATEDRECTANGLE },
      { label: t('brush'), value: AnnotationToolType.BRUSH },
    ],
    (o) => o.label
  );

  return (
    <div>
      <S_FieldLabel
        isRequired
        text={t('projects.details.annotation_tools.marking_tools.tool_type')}
      />
      <Select
        required
        onChange={(_, v) => {
          props.onChangeToolType(v.value);
        }}
        value={options.find((x) => x.value === props.toolType)}
        disabled={props.disabled}
        options={options}
      />
    </div>
  );
});
